module.exports = __webpack_public_path__ + "static/img/irole.771796f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/mz/irole.png
// module id = RT/Y
// module chunks = 7